import React, { useEffect, useState } from 'react'

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import { useNavigate } from "react-router-dom"

import { MdOutlinePayment } from "react-icons/md";
import { use } from 'react';


const ChitDetailsAddPayment = ({ close, chitData }) => {
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        cash_payment: "",
        online_payment: "",
    })


    const [chitDetailPayments, setChitDetailPayments] = useState([])
    const [validation, setvalidation] = useState(null)
    const [error, setError] = useState(null)
    const navigate = useNavigate();
    const [chitDetails, setChitDetails] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPaymentID, setSelectedPaymentID] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [payamentData, setPaymentData] = useState({
        cash_payment: "",
        online_payment: "",
    })



    console.log(chitDetails)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }
    const handleChangeForPayment = (e) => {
        const { name, value } = e.target;

        const newData = {
            ...payamentData,
            [name]: Number(value),
        };

        const total =
            Number(newData.cash_payment || 0) +
            Number(newData.online_payment || 0);

        const maxAmount = Number(chitDetails.payable_amount);

        // ❌ Prevent exceeding payable amount
        if (total > maxAmount) {
            setError("Total payment cannot exceed payable amount");
            return;
        }else if (newData.cash_payment  > maxAmount){
            setError("Total payment cannot exceed payable amount");
            return;
        }else if (newData.online_payment  > maxAmount){
            setError("Total payment cannot exceed payable amount");
            return;
        }

        setPaymentData(newData);
    };


    const openModal = (payment) => {
        setSelectedPaymentID(payment.id);
        setSelectedPayment(payment)
        setPaymentData({
            cash_payment: payment?.cash_payment || "",
            online_payment: payment?.online_payment || ""
        })
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const payamentUpdate = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(
                `public/api/chit/details/payment/${selectedPaymentID}`, payamentData,
                { headers: { Authorization: `Bearer ${token}` } }
            )
            closeModal()
            fetchData()
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
        }
    }


    const fetchData = async () => {
        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            const response = await axios.get(
                `public/api/chit/details/${chitData.id}/payment/history`,
                { headers: { Authorization: `Bearer ${token}` } }
            )

            setChitDetailPayments(response.data.chit_detail_payments)
            setChitDetails(response?.data)

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])
    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true)
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(
                `public/api/chit/details/${chitData.id}/payment`, formData,
                { headers: { Authorization: `Bearer ${token}` } }
            )

            toast.success(response.data.message)
            close()

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }

            setvalidation(error?.response?.data?.message)
            toast.error(error?.response?.data?.message)
            // setError("")
        } finally {
            setLoading(false)
        }
    }


    if (loading) {
        return (
            <>

                <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
                    <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-blue-500"></div>
                    <p className="text-lg text-gray-600">Loading...</p>
                </div>

            </>
        );
    }

    return (
        <div className='p-6'>

            <div className="flex items-center justify-end  w-full">
                <button
                    onClick={close}
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="black"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
            </div>


            <div className='flex flex-col items-center mt-6  '>


                <div className="bg-blue-500 text-white p-3  rounded-full">

                    <MdOutlinePayment className="h-6 w-6 " />
                </div>
                <h1 className='text-3xl font-bold mt-4'>Add Payment</h1>

                {/* <p className="text-gray-600 mt-2 text-center">
                    Complete the form below to add a new Chit Details to your chit fund.
                    All fields marked with <span className="text-red-500">*</span> are required.
                </p> */}
            </div>
            <div className=' border-b-2 mt-4 '></div>

            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-blue-100 rounded-full p-1'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                </svg>
                            </span> Name
                        </label>
                        <input
                            id="cash_payment"
                            name="cash_payment"
                            type="text"
                            placeholder="Enter Name"
                            value={chitDetails?.customer?.name}
                            onChange={handleChange}
                            autoComplete="cash_payment"
                            disabled
                            className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />

                    </div>

                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="13" height="13" color="#417505" fill="none">
                                    <path d="M9.1585 5.71223L8.75584 4.80625C8.49256 4.21388 8.36092 3.91768 8.16405 3.69101C7.91732 3.40694 7.59571 3.19794 7.23592 3.08785C6.94883 3 6.6247 3 5.97645 3C5.02815 3 4.554 3 4.15597 3.18229C3.68711 3.39702 3.26368 3.86328 3.09497 4.3506C2.95175 4.76429 2.99278 5.18943 3.07482 6.0397C3.94815 15.0902 8.91006 20.0521 17.9605 20.9254C18.8108 21.0075 19.236 21.0485 19.6496 20.9053C20.137 20.7366 20.6032 20.3131 20.818 19.8443C21.0002 19.4462 21.0002 18.9721 21.0002 18.0238C21.0002 17.3755 21.0002 17.0514 20.9124 16.7643C20.8023 16.4045 20.5933 16.0829 20.3092 15.8362C20.0826 15.6393 19.7864 15.5077 19.194 15.2444L18.288 14.8417C17.6465 14.5566 17.3257 14.4141 16.9998 14.3831C16.6878 14.3534 16.3733 14.3972 16.0813 14.5109C15.7762 14.6297 15.5066 14.8544 14.9672 15.3038C14.4304 15.7512 14.162 15.9749 13.834 16.0947C13.5432 16.2009 13.1588 16.2403 12.8526 16.1951C12.5071 16.1442 12.2426 16.0029 11.7135 15.7201C10.0675 14.8405 9.15977 13.9328 8.28011 12.2867C7.99738 11.7577 7.85602 11.4931 7.80511 11.1477C7.75998 10.8414 7.79932 10.457 7.90554 10.1663C8.02536 9.83828 8.24905 9.56986 8.69643 9.033C9.14586 8.49368 9.37058 8.22402 9.48939 7.91891C9.60309 7.62694 9.64686 7.3124 9.61719 7.00048C9.58618 6.67452 9.44362 6.35376 9.1585 5.71223Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                            </span>
                            Phone Number {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="number"
                            placeholder="Enter phone"
                            value={chitDetails?.customer?.phone}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>

                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-blue-100 rounded-full p-1'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <path d="M14.7109 2.25013C16.2724 2.25013 17.3703 2.22221 18.4062 2.99524C19.4327 3.76157 19.6798 4.66971 20.0585 5.94544C20.5461 7.58794 21.0667 9.88206 21.4218 12.9249C21.6254 14.6691 21.7903 16.0663 21.7412 17.1925C21.6903 18.358 21.4081 19.3211 20.663 20.1583C19.9081 21.0064 18.9348 21.3919 17.7197 21.5743C16.5351 21.7522 15.0183 21.7501 13.1083 21.7501H10.8916C8.98152 21.7501 7.46476 21.7522 6.28022 21.5743C5.06503 21.3919 4.09177 21.0065 3.33686 20.1583C2.59171 19.3211 2.30962 18.3581 2.25874 17.1925C2.20963 16.0663 2.37452 14.6691 2.57807 12.9249C2.9332 9.88208 3.45378 7.58794 3.94136 5.94544C4.32013 4.66951 4.5677 3.76164 5.59468 2.99524C6.63056 2.22232 7.72749 2.25013 9.28901 2.25013H14.7109ZM9.28901 3.75013C7.58724 3.75013 7.05162 3.77922 6.49116 4.19739C5.92205 4.62222 5.77949 5.02594 5.37983 6.3722C4.91791 7.92823 4.41392 10.1374 4.06831 13.0988C3.859 14.8923 3.71512 16.1492 3.75776 17.1271C3.79873 18.0656 4.01009 18.658 4.45796 19.1613C4.8962 19.6534 5.48639 19.9383 6.50288 20.0909C7.55032 20.2482 8.93425 20.2501 10.8916 20.2501H13.1083C15.0656 20.2501 16.4496 20.2482 17.497 20.0909C18.5137 19.9383 19.1046 19.6537 19.5429 19.1613C19.9907 18.6581 20.2012 18.0655 20.2421 17.1271C20.2848 16.1492 20.1409 14.8923 19.9316 13.0988C19.586 10.1374 19.082 7.92823 18.6201 6.3722C18.2204 5.02588 18.0779 4.62224 17.5087 4.19739C16.9482 3.77914 16.4127 3.75013 14.7109 3.75013H9.28901ZM14.9999 6.25013C15.4141 6.25015 15.7499 6.58599 15.7499 7.00013C15.7499 9.07118 14.071 10.7501 12 10.7501C9.92888 10.7501 8.24995 9.07119 8.24995 7.00013C8.25002 6.58597 8.58578 6.25013 8.99995 6.25013C9.4141 6.25015 9.74988 6.58599 9.74995 7.00013C9.74995 8.24277 10.7573 9.25013 12 9.25013C13.2426 9.2501 14.2499 8.24275 14.2499 7.00013C14.25 6.58597 14.5858 6.25013 14.9999 6.25013Z" fill="#141B34" />
                                </svg>
                            </span> Plan <span className='text-lg'> *</span>
                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Plan"
                            value={chitDetails?.active_plan?.group?.plan?.name}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>

                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-green-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <path d="M14.7109 2.25013C16.2724 2.25013 17.3703 2.22221 18.4062 2.99524C19.4327 3.76157 19.6798 4.66971 20.0585 5.94544C20.5461 7.58794 21.0667 9.88206 21.4218 12.9249C21.6254 14.6691 21.7903 16.0663 21.7412 17.1925C21.6903 18.358 21.4081 19.3211 20.663 20.1583C19.9081 21.0064 18.9348 21.3919 17.7197 21.5743C16.5351 21.7522 15.0183 21.7501 13.1083 21.7501H10.8916C8.98152 21.7501 7.46476 21.7522 6.28022 21.5743C5.06503 21.3919 4.09177 21.0065 3.33686 20.1583C2.59171 19.3211 2.30962 18.3581 2.25874 17.1925C2.20963 16.0663 2.37452 14.6691 2.57807 12.9249C2.9332 9.88208 3.45378 7.58794 3.94136 5.94544C4.32013 4.66951 4.5677 3.76164 5.59468 2.99524C6.63056 2.22232 7.72749 2.25013 9.28901 2.25013H14.7109ZM9.28901 3.75013C7.58724 3.75013 7.05162 3.77922 6.49116 4.19739C5.92205 4.62222 5.77949 5.02594 5.37983 6.3722C4.91791 7.92823 4.41392 10.1374 4.06831 13.0988C3.859 14.8923 3.71512 16.1492 3.75776 17.1271C3.79873 18.0656 4.01009 18.658 4.45796 19.1613C4.8962 19.6534 5.48639 19.9383 6.50288 20.0909C7.55032 20.2482 8.93425 20.2501 10.8916 20.2501H13.1083C15.0656 20.2501 16.4496 20.2482 17.497 20.0909C18.5137 19.9383 19.1046 19.6537 19.5429 19.1613C19.9907 18.6581 20.2012 18.0655 20.2421 17.1271C20.2848 16.1492 20.1409 14.8923 19.9316 13.0988C19.586 10.1374 19.082 7.92823 18.6201 6.3722C18.2204 5.02588 18.0779 4.62224 17.5087 4.19739C16.9482 3.77914 16.4127 3.75013 14.7109 3.75013H9.28901ZM14.9999 6.25013C15.4141 6.25015 15.7499 6.58599 15.7499 7.00013C15.7499 9.07118 14.071 10.7501 12 10.7501C9.92888 10.7501 8.24995 9.07119 8.24995 7.00013C8.25002 6.58597 8.58578 6.25013 8.99995 6.25013C9.4141 6.25015 9.74988 6.58599 9.74995 7.00013C9.74995 8.24277 10.7573 9.25013 12 9.25013C13.2426 9.2501 14.2499 8.24275 14.2499 7.00013C14.25 6.58597 14.5858 6.25013 14.9999 6.25013Z" fill="#141B34" />
                                </svg>
                            </span>
                            Group {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Group"
                            value={chitDetails?.active_plan?.group?.group_name}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>

                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-yellow-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#f8e71c" fill="none">
                                    <defs />
                                    <path fill="#141B34" d="M10.989,2.25 L13.011,2.25 C14.716,2.25 16.114,2.25 17.25,2.366 L17.25,2 C17.25,1.586 17.586,1.25 18,1.25 C18.414,1.25 18.75,1.586 18.75,2 L18.75,2.635 C19.555,2.863 20.233,3.234 20.799,3.844 C21.576,4.685 21.922,5.748 22.088,7.08 C22.25,8.384 22.25,10.057 22.25,12.19 L22.25,12.81 C22.25,14.943 22.25,16.616 22.088,17.92 C21.922,19.252 21.576,20.315 20.799,21.156 C20.013,22.005 19.007,22.39 17.749,22.573 C16.531,22.75 14.974,22.75 13.011,22.75 L10.989,22.75 C9.026,22.75 7.469,22.75 6.251,22.573 C4.993,22.39 3.987,22.005 3.202,21.156 C2.424,20.315 2.078,19.252 1.912,17.92 C1.75,16.616 1.75,14.944 1.75,12.81 L1.75,12.19 C1.75,10.056 1.75,8.384 1.912,7.08 C2.078,5.748 2.424,4.685 3.202,3.844 C3.766,3.234 4.445,2.863 5.25,2.635 L5.25,2 C5.25,1.586 5.586,1.25 6,1.25 C6.414,1.25 6.75,1.586 6.75,2 L6.75,2.366 C7.886,2.25 9.284,2.25 10.989,2.25 Z M3.289,8.75 C3.251,9.707 3.25,10.851 3.25,12.243 L3.25,12.757 C3.25,14.955 3.251,16.534 3.401,17.735 C3.548,18.921 3.828,19.624 4.303,20.137 C4.769,20.641 5.397,20.933 6.467,21.089 C7.565,21.248 9.012,21.25 11.05,21.25 L12.95,21.25 C14.988,21.25 16.435,21.248 17.533,21.089 C18.603,20.933 19.231,20.641 19.697,20.137 C20.171,19.624 20.452,18.921 20.599,17.735 C20.749,16.534 20.75,14.955 20.75,12.757 L20.75,12.243 C20.75,10.851 20.75,9.707 20.711,8.75 Z M12.95,3.75 L11.05,3.75 C9.182,3.75 7.811,3.752 6.75,3.875 L6.75,4 C6.75,4.414 6.414,4.75 6,4.75 C5.657,4.75 5.368,4.52 5.279,4.206 C4.871,4.368 4.562,4.583 4.303,4.863 C3.83,5.373 3.551,6.073 3.403,7.25 L20.597,7.25 C20.449,6.073 20.17,5.373 19.697,4.863 C19.438,4.583 19.129,4.368 18.721,4.206 C18.632,4.52 18.343,4.75 18,4.75 C17.586,4.75 17.25,4.414 17.25,4 L17.25,3.875 C16.189,3.752 14.818,3.75 12.95,3.75 Z M11.208,11.613 C11.422,11.968 11.308,12.429 10.953,12.642 C10.23,13.078 9.75,13.868 9.75,14.769 C9.75,16.139 10.861,17.25 12.231,17.25 C13.132,17.25 13.922,16.77 14.358,16.047 C14.571,15.692 15.032,15.578 15.387,15.792 C15.742,16.006 15.856,16.467 15.642,16.821 C14.947,17.975 13.68,18.75 12.231,18.75 C10.032,18.75 8.25,16.968 8.25,14.769 C8.25,13.32 9.025,12.053 10.179,11.358 C10.533,11.144 10.994,11.258 11.208,11.613 Z M14,12 L14.009,12 C14.561,12 15.009,12.448 15.009,13 C15.009,13.552 14.561,14 14.009,14 L14,14 C13.448,14 13,13.552 13,13 C13,12.448 13.448,12 14,12 Z" />
                                </svg>
                            </span>
                            Month {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Group"
                            value={chitDetails?.month}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-gray-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#9b9b9b" fill="none">
                                    <defs />
                                    <path fill="#141B34" d="M10.542,22.148 L10.541,22.148 L8.629,20.942 C8.374,20.781 8.084,20.598 8.008,20.59 L8.007,20.59 C7.931,20.59 7.59,20.804 7.379,20.937 L7.379,20.937 L7.379,20.937 L7.371,20.942 C7.291,20.993 7.185,21.067 7.072,21.146 L7.063,21.152 C6.332,21.664 5.108,22.52 4.056,21.842 C3.25,21.322 3.25,20.372 3.25,18.646 L3.25,8.054 C3.25,5.094 3.25,3.464 4.347,2.359 C5.445,1.25 7.063,1.25 10,1.25 L14,1.25 C16.938,1.25 18.556,1.25 19.654,2.359 C20.75,3.464 20.75,5.094 20.75,8.054 L20.75,18.646 C20.75,20.371 20.75,21.322 19.945,21.841 C18.893,22.519 17.67,21.664 16.938,21.152 L16.938,21.152 L16.937,21.151 L16.897,21.123 C16.796,21.052 16.702,20.987 16.629,20.941 C16.374,20.78 16.084,20.597 16.008,20.589 L16.007,20.589 C15.931,20.589 15.59,20.803 15.379,20.936 L15.371,20.941 L13.46,22.146 C12.884,22.51 12.504,22.75 12,22.75 L12,22.751 C11.496,22.751 11.116,22.511 10.542,22.148 Z M8.059,19.091 C8.532,19.107 8.889,19.332 9.429,19.673 L11.34,20.878 C11.612,21.05 11.919,21.243 12,21.25 C12.08,21.243 12.378,21.055 12.645,20.887 L12.645,20.887 L12.658,20.879 L14.571,19.673 L14.574,19.671 C15.127,19.323 15.525,19.072 16.059,19.091 C16.532,19.107 16.889,19.332 17.429,19.673 C17.542,19.744 17.666,19.831 17.797,19.923 C18.703,20.557 19.019,20.637 19.123,20.586 C19.25,20.392 19.25,19.505 19.25,18.647 L19.25,8.055 C19.25,5.41 19.25,4.083 18.589,3.416 C17.931,2.751 16.617,2.751 14,2.751 L10,2.751 C7.383,2.751 6.07,2.751 5.412,3.416 C4.75,4.083 4.75,5.411 4.75,8.055 L4.75,18.647 C4.75,19.506 4.75,20.393 4.877,20.587 C4.98,20.638 5.296,20.559 6.203,19.924 C6.334,19.832 6.458,19.746 6.571,19.674 C7.106,19.337 7.497,19.091 8.004,19.091 Z M15.25,9.002 L15.25,9.245 C15.86,9.442 16.37,9.876 16.61,10.471 C16.765,10.855 16.58,11.292 16.196,11.447 C15.811,11.602 15.374,11.417 15.219,11.033 C15.142,10.841 14.886,10.627 14.5,10.627 C13.989,10.627 13.75,10.97 13.75,11.189 C13.75,11.409 13.989,11.752 14.5,11.752 C15.645,11.752 16.75,12.584 16.75,13.814 C16.75,14.77 16.084,15.485 15.25,15.757 L15.25,16.002 C15.25,16.416 14.914,16.752 14.5,16.752 C14.086,16.752 13.75,16.416 13.75,16.002 L13.75,15.759 C13.14,15.562 12.63,15.128 12.39,14.533 C12.235,14.149 12.42,13.712 12.804,13.557 C13.189,13.401 13.626,13.587 13.781,13.971 C13.858,14.163 14.114,14.377 14.5,14.377 C15.011,14.377 15.25,14.034 15.25,13.814 C15.25,13.595 15.011,13.252 14.5,13.252 C13.355,13.252 12.25,12.42 12.25,11.189 C12.25,10.234 12.916,9.519 13.75,9.247 L13.75,9.002 C13.75,8.588 14.086,8.252 14.5,8.252 C14.914,8.252 15.25,8.588 15.25,9.002 Z M16,6.752 L8,6.752 C7.586,6.752 7.25,6.416 7.25,6.002 C7.25,5.588 7.586,5.252 8,5.252 L16,5.252 C16.414,5.252 16.75,5.588 16.75,6.002 C16.75,6.416 16.414,6.752 16,6.752 Z M10.75,10.002 C10.75,10.416 10.414,10.752 10,10.752 L8,10.752 C7.586,10.752 7.25,10.416 7.25,10.002 C7.25,9.588 7.586,9.252 8,9.252 L10,9.252 C10.414,9.252 10.75,9.588 10.75,10.002 Z" />
                                </svg>
                            </span>
                            Payment Status {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Payment Status"
                            value={chitDetails?.payment_status}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-blue-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#302163" fill="none">
                                    <defs />
                                    <path fill="#141B34" d="M13.011,21.817 L12.923,21.707 C12.715,21.447 12.379,21.298 12,21.298 C11.621,21.298 11.285,21.448 11.077,21.708 L10.991,21.816 C10.515,22.41 9.783,22.75 8.982,22.75 C8.181,22.75 7.449,22.41 6.974,21.817 L6.422,21.127 C6.343,21.028 6.203,20.974 6.048,20.982 C5.902,20.99 5.778,21.053 5.717,21.15 C5.347,21.736 4.694,22.06 3.973,22.014 C3.256,21.97 2.637,21.572 2.356,20.975 C2.288,20.827 2.271,20.685 2.287,20.556 L2.285,20.528 C2.283,20.513 2.282,20.495 2.279,20.473 C2.232,20.075 2.25,19.922 2.299,19.691 L4.222,10.608 L4.224,10.598 L4.226,10.59 C4.728,8.225 5.005,6.922 6.042,6.086 C7.079,5.25 8.423,5.25 10.864,5.25 L13.14,5.25 C15.58,5.25 16.925,5.25 17.962,6.086 C19,6.924 19.277,8.229 19.78,10.597 L19.78,10.597 L19.78,10.598 L19.782,10.608 L21.705,19.689 C21.754,19.923 21.772,20.076 21.725,20.476 C21.723,20.497 21.721,20.515 21.72,20.53 L21.717,20.553 C21.733,20.681 21.717,20.823 21.65,20.969 C21.367,21.571 20.747,21.969 20.03,22.014 C19.308,22.06 18.656,21.736 18.286,21.15 C18.225,21.053 18.101,20.99 17.955,20.982 C17.801,20.974 17.661,21.027 17.581,21.126 L17.029,21.816 C16.554,22.409 15.822,22.749 15.021,22.749 L15.019,22.75 C14.218,22.75 13.486,22.41 13.011,21.817 Z M14.095,20.77 L14.183,20.88 C14.368,21.111 14.681,21.249 15.019,21.249 C15.357,21.249 15.67,21.111 15.856,20.879 L16.408,20.189 C16.789,19.712 17.399,19.448 18.036,19.484 C18.666,19.519 19.233,19.842 19.553,20.348 C19.655,20.509 19.837,20.522 19.937,20.517 C20.048,20.51 20.153,20.472 20.222,20.417 C20.273,20.376 20.273,20.305 20.273,20.305 C20.273,20.305 20.255,20.089 20.237,20.002 L18.314,10.92 C17.867,8.811 17.643,7.757 17.02,7.254 C16.395,6.75 15.307,6.75 13.14,6.75 L10.864,6.75 C8.697,6.75 7.609,6.75 6.984,7.254 C6.361,7.757 6.137,8.81 5.692,10.91 C5.692,10.91 3.786,19.913 3.767,20.001 C3.748,20.089 3.734,20.297 3.734,20.297 L3.781,20.419 C3.781,20.419 3.955,20.511 4.066,20.518 C4.166,20.524 4.348,20.51 4.45,20.349 C4.77,19.843 5.337,19.52 5.967,19.485 C6.604,19.449 7.214,19.713 7.595,20.191 L8.147,20.881 C8.333,21.113 8.646,21.251 8.984,21.251 C9.322,21.251 9.635,21.113 9.821,20.88 L9.907,20.772 C10.403,20.153 11.166,19.798 12.002,19.798 L12,19.797 C12.836,19.797 13.6,20.152 14.095,20.77 Z M20.997,10.04 C20.698,9.753 20.689,9.278 20.976,8.98 C21.25,8.696 21.259,8.266 21.247,6.95 L21.245,6.806 C21.244,6.604 21.242,6.386 21.242,6.152 C21.242,4.454 21.242,3.518 20.867,3.128 C20.517,2.765 19.734,2.75 17.995,2.75 L6.005,2.75 C4.267,2.75 3.483,2.765 3.134,3.128 C2.758,3.519 2.758,4.454 2.758,6.152 C2.758,6.445 2.756,6.711 2.753,6.955 C2.741,8.267 2.75,8.696 3.023,8.98 C3.31,9.279 3.301,9.753 3.003,10.04 C2.705,10.327 2.23,10.318 1.943,10.02 C1.232,9.282 1.24,8.401 1.254,6.942 L1.255,6.793 C1.257,6.595 1.259,6.382 1.259,6.152 C1.259,4.064 1.259,2.913 2.055,2.088 C2.861,1.25 3.978,1.25 6.006,1.25 L17.996,1.25 C20.024,1.25 21.141,1.25 21.948,2.088 C22.743,2.914 22.743,4.064 22.743,6.152 C22.743,6.438 22.745,6.698 22.747,6.937 C22.761,8.449 22.768,9.281 22.057,10.02 C21.91,10.173 21.713,10.25 21.516,10.25 C21.329,10.25 21.142,10.18 20.997,10.04 Z M8,14.75 C7.586,14.75 7.25,14.414 7.25,14 C7.25,13.586 7.586,13.25 8,13.25 L14,13.25 C14.414,13.25 14.75,13.586 14.75,14 C14.75,14.414 14.414,14.75 14,14.75 Z M12,10.75 L9,10.75 C8.586,10.75 8.25,10.414 8.25,10 C8.25,9.586 8.586,9.25 9,9.25 L12,9.25 C12.414,9.25 12.75,9.586 12.75,10 C12.75,10.414 12.414,10.75 12,10.75 Z" />
                                </svg>
                            </span>
                            Payable Amount  {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Payable Amount"
                            value={chitDetails?.payable_amount}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-orange-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#f5a623" fill="none">
                                    <defs />
                                    <path fill="#141B34" d="M12,22.751 C11.496,22.751 11.116,22.511 10.542,22.148 L10.541,22.148 L8.629,20.942 C8.374,20.781 8.084,20.598 8.008,20.59 L8.007,20.59 C7.931,20.59 7.59,20.804 7.379,20.937 L7.379,20.937 L7.371,20.942 C7.291,20.993 7.185,21.067 7.072,21.146 L7.063,21.152 C6.332,21.664 5.108,22.52 4.056,21.842 C3.25,21.322 3.25,20.372 3.25,18.646 L3.25,8.054 C3.25,5.094 3.25,3.464 4.347,2.359 C5.445,1.25 7.063,1.25 10,1.25 L14,1.25 C16.938,1.25 18.556,1.25 19.654,2.359 C20.75,3.464 20.75,5.094 20.75,8.054 L20.75,18.646 C20.75,20.371 20.75,21.322 19.945,21.841 C18.893,22.519 17.67,21.664 16.938,21.152 L16.938,21.152 L16.937,21.151 L16.897,21.123 C16.796,21.052 16.702,20.987 16.629,20.941 C16.374,20.78 16.084,20.597 16.008,20.589 L16.007,20.589 C15.931,20.589 15.59,20.803 15.379,20.936 L15.371,20.941 L13.46,22.146 C12.884,22.51 12.504,22.75 12,22.75 Z M8.004,19.091 L8.059,19.091 C8.532,19.107 8.889,19.332 9.429,19.673 L11.34,20.878 C11.612,21.05 11.919,21.243 12,21.25 C12.08,21.243 12.378,21.055 12.645,20.887 L12.658,20.879 L14.571,19.673 L14.574,19.671 C15.127,19.323 15.525,19.072 16.059,19.091 C16.532,19.107 16.889,19.332 17.429,19.673 C17.542,19.744 17.666,19.831 17.797,19.923 C18.703,20.557 19.019,20.637 19.123,20.586 C19.25,20.392 19.25,19.505 19.25,18.647 L19.25,8.055 C19.25,5.41 19.25,4.083 18.589,3.416 C17.931,2.751 16.617,2.751 14,2.751 L10,2.751 C7.383,2.751 6.07,2.751 5.412,3.416 C4.75,4.083 4.75,5.411 4.75,8.055 L4.75,18.647 C4.75,19.506 4.75,20.393 4.877,20.587 C4.98,20.638 5.296,20.559 6.203,19.924 C6.334,19.832 6.458,19.746 6.571,19.674 C7.106,19.337 7.497,19.091 8.004,19.091 Z M8,7.752 C7.586,7.752 7.25,7.416 7.25,7.002 C7.25,6.588 7.586,6.252 8,6.252 L14,6.252 C14.414,6.252 14.75,6.588 14.75,7.002 C14.75,7.416 14.414,7.752 14,7.752 Z M11,11.752 L8,11.752 C7.586,11.752 7.25,11.416 7.25,11.002 C7.25,10.588 7.586,10.252 8,10.252 L11,10.252 C11.414,10.252 11.75,10.588 11.75,11.002 C11.75,11.416 11.414,11.752 11,11.752 Z" />
                                </svg>
                            </span>
                            Pending  Amount  {""}

                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Pending Amount"
                            value={chitDetails?.pending_amount}
                            onChange={handleChange}
                            disabled
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />

                    </div>
                    <div>
                        <label htmlFor="payable_amount" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-gray-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#50e3c2" fill="none">
                                    <defs />
                                    <path fill="#141B34" d="M9.939,2.644 C11.798,0.785 14.812,0.785 16.671,2.644 L21.356,7.329 C23.215,9.188 23.215,12.202 21.356,14.061 L14.167,21.25 L20,21.25 C20.414,21.25 20.75,21.586 20.75,22 C20.75,22.414 20.414,22.75 20,22.75 L4,22.75 C3.586,22.75 3.25,22.414 3.25,22 C3.25,21.586 3.586,21.25 4,21.25 L7.223,21.25 L2.644,16.671 C0.785,14.812 0.785,11.798 2.644,9.939 Z M8.389,20.295 C9.663,21.568 11.727,21.568 13,20.295 L20.295,13 C21.568,11.727 21.568,9.663 20.295,8.389 L16.254,4.348 L4.348,16.254 Z M11,3.705 L3.705,11 C2.574,12.13 2.448,13.885 3.325,15.156 L15.156,3.325 C13.885,2.448 12.13,2.574 11,3.705 Z M19.162,10.524 C19.455,10.817 19.455,11.292 19.162,11.585 L16.962,13.784 C16.67,14.077 16.195,14.077 15.902,13.784 C15.609,13.491 15.609,13.016 15.902,12.723 L18.101,10.524 C18.394,10.231 18.869,10.231 19.162,10.524 Z M15.085,14.578 C15.378,14.871 15.378,15.346 15.085,15.639 L14.106,16.617 C13.814,16.91 13.339,16.91 13.046,16.617 C12.753,16.324 12.753,15.85 13.046,15.557 L14.025,14.578 C14.318,14.285 14.792,14.285 15.085,14.578 Z" />
                                </svg>
                            </span> Cash Payment
                        </label>
                        <input
                            id="cash_payment"
                            name="cash_payment"
                            type="number"
                            placeholder="Enter Cash Payment"
                            value={formData.cash_payment}
                            onChange={handleChange}
                            autoComplete="cash_payment"

                            className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <p className="text-red-600 text-sm mt-1">
                            {validation}
                        </p>

                    </div>
                    <div>
                        <label htmlFor="payable_amount" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.65 18.65C20.55 19.75 19.03 19.75 16 19.75H8C4.97 19.75 3.44998 19.75 2.34998 18.65C1.25 17.55 1.25 15.9301 1.25 13.0002V13V11V10.9998C1.25 8.05993 1.25 6.44998 2.34998 5.35001C3.44998 4.25001 4.97 4.25 8 4.25H16C19.03 4.25 20.55 4.25001 21.65 5.35001C22.75 6.44998 22.75 8.06993 22.75 10.9998V11V13V13.0002C22.75 15.9401 22.75 17.55 21.65 18.65ZM8 5.75C7.52195 5.75 7.08752 5.75 6.69269 5.75401C6.37664 7.77652 4.77652 9.37667 2.75401 9.69272C2.75 10.0875 2.75 10.522 2.75 11V13C2.75 13.4778 2.75 13.9121 2.75401 14.3068C4.77667 14.6229 6.37688 16.2233 6.69276 18.246C7.08757 18.25 7.52198 18.25 8 18.25H16C16.4735 18.25 16.9043 18.25 17.2961 18.2461C17.5854 16.2062 19.2045 14.5904 21.246 14.3062C21.25 13.9117 21.25 13.4776 21.25 13V11C21.25 10.5206 21.25 10.0851 21.246 9.68933C19.2297 9.36307 17.627 7.75949 17.3079 5.75402C16.9129 5.75 16.4783 5.75 16 5.75H8ZM3.41003 6.41C3.76625 6.05379 4.31179 5.88983 5.15043 5.81436C4.85976 6.95737 3.95738 7.85977 2.81437 8.15045C2.88985 7.31178 3.05382 6.76622 3.41003 6.41ZM3.41003 17.59C3.05375 17.2337 2.88979 16.688 2.81433 15.8491C3.95751 16.1398 4.86 17.0424 5.15055 18.1856C4.31184 18.1102 3.76626 17.9462 3.41003 17.59ZM20.59 17.59C20.2313 17.9487 19.6807 18.1124 18.8322 18.1872C19.104 17.0257 20.0234 16.1092 21.1864 15.8414C21.1112 16.6847 20.9473 17.2326 20.59 17.59ZM20.59 6.41C20.9459 6.76592 21.1099 7.31086 21.1854 8.14834C20.0465 7.85462 19.1429 6.95143 18.8504 5.81444C19.6886 5.88994 20.2339 6.05391 20.59 6.41ZM8.25 12C8.25 14.07 9.93 15.75 12 15.75C14.07 15.75 15.75 14.07 15.75 12C15.75 9.93 14.07 8.25 12 8.25C9.93 8.25 8.25 9.93 8.25 12ZM9.75 12C9.75 10.76 10.76 9.75 12 9.75C13.24 9.75 14.25 10.76 14.25 12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12Z" fill="currentColor" />
                                </svg>
                            </span> Online Payment
                        </label>
                        <input
                            id="online_payment"
                            name="online_payment"
                            type="number"
                            placeholder="Enter Online Payment"
                            value={formData.online_payment}
                            onChange={handleChange}
                            autoComplete="online_payment"

                            className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <p className="text-red-600 text-sm mt-1">
                            {validation}
                        </p>
                    </div>
                </div>
                {Number(chitDetails?.pending_amount) !== 0 && (
                    <div className="mt-6 text-right">
                        <button
                            type="submit"
                            className="inline-flex items-center gap-2 px-6 py-2 bg-[#0f172a] text-white text-sm font-medium rounded-md shadow hover:bg-indigo-700 transition-all"
                        >
                            Save
                        </button>
                    </div>
                )}


            </form>


            {chitDetailPayments.length > 0 && (
                <div className="p-4">
                    {/* ✅ Added scroll wrapper */}
                    <div className="overflow-x-auto">
                        <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 border">#</th>
                                    <th className="px-4 py-2 border">Date</th>
                                    <th className="px-4 py-2 border">Cash Payment</th>
                                    <th className="px-4 py-2 border">Online Payment</th>
                                    <th className="px-4 py-2 border">Total Payment</th>
                                    <th className="px-4 py-2 border">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chitDetailPayments?.length > 0 ? (
                                    chitDetailPayments.map((payment, index) => (
                                        <tr key={payment.id} className="text-center hover:bg-gray-50">
                                            <td className="px-4 py-2 border">{index + 1}</td>
                                            <td className="px-4 py-2 border">
                                                {new Date(payment.created_at).toLocaleString('en-IN', {
                                                    dateStyle: 'medium',
                                                    timeStyle: 'short',
                                                })}
                                            </td>
                                            <td className="px-4 py-2 border">{payment.cash_payment}</td>
                                            <td className="px-4 py-2 border">{payment.online_payment}</td>
                                            <td className="px-4 py-2 border">{payment.total_payment}</td>
                                            <td className="px-4 py-2 border">
                                                <button
                                                    onClick={() => openModal(payment)}
                                                    className="bg-[#0f172a] text-white px-3 py-1 rounded hover:bg-[#0f172ab8]"
                                                >
                                                    Edit
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-3 text-gray-500">
                                            No payments found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-xl w-96 shadow-lg">

                        {/* Header */}
                        <div className="flex justify-between mb-4">
                            <h2 className="text-lg font-semibold">
                                Add Payment
                            </h2>

                            <button onClick={closeModal}>✕</button>
                        </div>

                        {/* Cash Payment */}
                        <div>
                            <label className="block text-sm font-medium">
                                Cash Payment
                            </label>
                            <input
                                name="cash_payment"
                                type="number"
                                value={payamentData.cash_payment}
                                onChange={handleChangeForPayment}
                                className="w-full border rounded p-2 mt-1"
                                placeholder="Enter Cash Payment"
                            />
                            
                        </div>

                        {/* Online Payment */}
                        <div className="mt-4">
                            <label className="block text-sm font-medium">
                                Online Payment
                            </label>
                            <input
                                name="online_payment"
                                type="number"
                                value={payamentData.online_payment}
                                onChange={handleChangeForPayment}
                                className="w-full border rounded p-2 mt-1"
                                placeholder="Enter Online Payment"
                            />
                        </div>
                        {error &&  <p className="text-red-500">{error}</p> }
                       
                        {/* Buttons */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-gray-300 rounded"
                            >
                                Cancel
                            </button>

                            <button
                                className="px-4 py-2 bg-[#0f172a] text-white rounded"
                                onClick={payamentUpdate}
                            >
                                Upate Payment
                            </button>
                        </div>
                    </div>
                </div>
            )}



        </div>
    )
}

export default ChitDetailsAddPayment
